import {
    SectionHeading,
    SponsoredSectionHeading,
} from "../../../../components/Heading/component";

/**
 * This component handles creating a SectionHeading component for lineups and widgets
 *
 * @param {string} title heading title
 * @param {string} link heading title link url
 * @param {boolean} linkVisible display heading title link if true
 * @param {string} description heading description
 * @param {string} image heading image
 * @param {string} imageAlt heading image alt text
 * @param {string} imageLink heading image link url
 * @param {string} variant variant (e.g. "PresentedBy")
 * @param {string} headingLevel heading tag
 * @param {boolean} darkMode darkMode
 *
 * @returns {JSX} SectionHeading component
 */
export const SectionHeadingContainer = (props) => {
    const {
        title,
        link,
        linkVisible,
        description,
        image,
        imageAlt,
        imageLink,
        variant,
        headingLevel,
        darkMode,
    } = props;

    if (!title && !description) {
        return null;
    }
    const sectionHeading = image ? (
        <SponsoredSectionHeading
            text={title}
            sponsoredImageUrl={image}
            sponsoredImageAlt={imageAlt ? imageAlt : null}
            variant={variant ? variant : null}
            link={link ? link : null}
            sponsoredImageLink={imageLink ? imageLink : null}
            size="sm"
            headingLevel={headingLevel}
            darkMode={darkMode}
            external={imageLink ? true : false}
        />
    ) : (
        <SectionHeading
            text={title}
            description={description}
            link={linkVisible && link ? link : null}
            external={linkVisible && link && link.charAt(0) !== "/"}
        />
    );

    return sectionHeading;
};

/**
 * This component handles creating a hidden section heading for screen readers
 *
 * @param {string} title
 *
 * @returns {JSX} hidden section heading for screen readers
 */
export const HiddenSectionHeading = ({ title }) => {
    if (!title) {
        return null;
    }

    return (
        <h2 data-testid="hidden-heading" className="a11y">
            {title}
        </h2>
    );
};
